// import React from "react";
import React from "react";
import "../styles/landingpage.css";
import { getBannerImage } from "../utils/CommonFunction";

type Props = {
  phoneNo: string;
  handlePhoneNoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error: string;
  checkUserSubscriptions: (phoneNumber: string) => Promise<void>;
  isCheckRadioBtn: boolean;
  setIsCheckRadioBtn: React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<string>>;
  isHe: boolean;
  parameter: string ;
  isEnc: boolean;
  isLoader: boolean;
  utm_campaign: string;
};

export const LandingJazzCash = (props: Props) => {
   const selectedImg = getBannerImage(
    props.utm_campaign,
    props.parameter
  );
  return (
    <div className="dm-section jazzcashlanding">
      <div className="main-content">
        <img
          src={selectedImg}
          alt="sports"
          width={345}
          height={333}
          className="lp-main-image"
        />
        <div className="lp-absolute-content">
          <div className="numberdiv">
            <p className="landingtext">Please enter your jazz cash number.</p>
            <form>
              <div className="input-wraper">
                <span>
                  <img
                    src="https://cdn.econceptionscdn.com/Tamasha/imgs/jazzcash_logo.webp"
                    width={40}
                    height={28}
                    alt="jazzcash"
                  />
                </span>
                <input
                  type="number"
                  placeholder="3XX - XXXXXXX"
                  className="numberinput"
                  // max={10}
                  value={props.phoneNo}
                  disabled={props.isHe || props.isEnc}
                  onChange={(e) => {
                    props.handlePhoneNoChange(e);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      props.checkUserSubscriptions(props.phoneNo);
                    }
                  }}
                />
              </div>

              {props.error.length > 0 && <p className="error">{props.error}</p>}

              {!props.isHe && (
                <div className="continue-jazzcash">
                  <span
                    className={`blue-btn ${props.isLoader ? "disabled-btn" : ""}`}
                    onClick={() => {
                      props.checkUserSubscriptions(props.phoneNo);
                    }}
                    style={{
                      pointerEvents: props.isLoader ? "none" : "auto",
                      opacity: props.isLoader ? 0.6 : 1,
                    }}
                  >
                    {props.isLoader ? "Loading..." : "Continue"}
                  </span>
                </div>
              )}
            </form>
          </div>

          <div className="otpDiv">
            <div className="policytext">
              <div className="checkflex">
                <input
                  type="checkbox"
                  checked={props.isCheckRadioBtn}
                  onChange={() => {
                    props.setError("");
                    props.setIsCheckRadioBtn(!props.isCheckRadioBtn);
                  }}
                />
                <p>
                  By signing in, you agree to the{" "}
                  <a href="https://tamashaweb.com/terms-of-use" target="_blank">
                    Terms of Use
                  </a>{" "}
                  and{" "}
                  <a href="/privacy-policy" target="_blank">
                    Privacy Policy.
                  </a>
                </p>
              </div>

              <div className="continue-text">
                * Continue click krne se aap ke account se Rs. 1 kat jayega. Yeh
                offer 24 hours ke liye valid hai jis ke baad automatically Rs.
                360/month inc. tax deduct honge.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default LandingJazzCash;
